import { Button, Form } from 'antd';
import { t } from 'i18next';
import React from 'react';
import ExtraTab from 'src/app/components/ExtraTabcomponent/ExtraTab';
import showModal from 'src/app/components/ShowModalComponent/ShowModal';
import { ICustomTabs } from 'src/app/components/TabLayoutComponent/tab-layout.config';
import TabLayout from 'src/app/components/TabLayoutComponent/TabLayout';
import AddModuleForm from 'src/app/forms/StartModuleForm/StartModuleForm';
import { formHelper } from 'src/app/helpers';
import { checkPermission, getPermissionKey } from 'src/app/helpers/permission.helper';
import usePermissions from 'src/app/hooks/usePermissions';
import { useGetModulesAndMachinesQuery } from 'src/app/redux/controlPanel/controlPanelSlice';
import { RunningResultType } from 'src/app/services/control-panel/control-panel.service.type';
import { routes } from 'src/configs/permissions.dictionary';
import AddInteractionIcon from 'src/icons/AddInteractionIcon';

const LazyRunningModulesComponent = React.lazy(() => import('./RunningModulesPage/RunningModules'));

const LazyMachinesComponent = React.lazy(() => import('./MachinesPage/Machines'));

const ControlPanelComponent = () => {
  const { permissions } = usePermissions();
  const { data: modulesAndMachines } = useGetModulesAndMachinesQuery(
    { name: 'modules and Machines' },
    {
      pollingInterval: 5000,
    },
  );

  const modules: RunningResultType[] = [];
  const machines: any = [];

  if (modulesAndMachines) {
    const moduleAndMachineNames: string[] = Object.keys(modulesAndMachines);
    moduleAndMachineNames.forEach((name) => {
      if (name === 'machine') {
        machines.push(...modulesAndMachines[name]);
      } else {
        modules.push(...modulesAndMachines[name]);
      }
    });
  }

  const modulesWithArchive = modules.reduce((acc: RunningResultType[], module) => {
    if (module.key?.startsWith('nginrSurfer') && !acc.find((val) => val.archive)) {
      acc.push({ ...module, archive: true });
    } else {
      acc.push(module);
    }
    return acc;
  }, []);

  const [addModuleForm] = Form.useForm();
  const onAddModule = (event: any) => {
    showModal({
      event,
      title: 'Start New Module',
      content: <AddModuleForm form={addModuleForm} />,
      onSave: (modal) => formHelper.submitForm(addModuleForm, modal),
    });
  };

  const addModulePermission = checkPermission(permissions, [routes['/Portal'], 'ControlPanel', 'StartModule']);
  const addModuleBtn = addModulePermission ? (
    <ExtraTab bgTheme onClick={(e) => onAddModule(e)} iconTheme icon={<AddInteractionIcon />} text="Start New Module" />
  ) : null;

  const tabItems: ICustomTabs[] = [
    {
      key: '1',
      label: <Button>{t('settingsPage.controlPanel.runningModules.tabName')}</Button>,
      children: <LazyRunningModulesComponent data={modulesWithArchive} />,
      permission: getPermissionKey([routes['/Portal'], 'ControlPanel', 'RunningModules']),
      extendedContents: addModuleBtn,
    },
    {
      key: '2',
      label: <Button>{t('settingsPage.controlPanel.machines.tabName')}</Button>,
      children: <LazyMachinesComponent data={machines} />,
      permission: getPermissionKey([routes['/Portal'], 'ControlPanel', 'Machines']),
      extendedContents: addModuleBtn,
    },
  ];

  return <TabLayout paramName="subTab" items={tabItems} className="tabs-with-border-container" />;
};

export default ControlPanelComponent;
